import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import Text from 'components/common/Text';
import { observer } from 'mobx-react';
import { AppTheme } from 'styles/theme';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import UtilityGraph from './UtilityGraph';
import useDepsContainer from 'hooks/useDepsContainer';

interface UtilityProps {}

const Utility = (props: UtilityProps) => {
  const styles = useStyles(props);

  const { uiStore } = useDepsContainer();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));

  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  return (
    <Flex
      column
      className={styles.utility}
      id={'pumpkin'}
      width={mdDown ? '100vw' : '100%'}
      px={mdDown ? 6 : 6}
      mb={mdDown ? -10 : 0}
    >
      <Flex width={'100%'} center className={mdDown ? styles.utilityTitleMd : styles.utilityTitle}>
        {cachedT('PumpkinEconomicSystemTitle')}
        <em></em>
      </Flex>

      <Flex width={'100%'} center mt={2.25} column>
        <Flex maxWidth={1100}>
          <Flex
            className={styles.subText}
            color={'#5F606D'}
            textAlign={'center'}
            style={{ fontSize: mdDown ? 16 : 18 }}
          >
            <div dangerouslySetInnerHTML={{ __html: t('PumpkinEconomicSystemContent') }} />
          </Flex>
        </Flex>
      </Flex>

      <Flex width={'100%'} mt={mdDown ? 2 : 8} center>
        <UtilityGraph />
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    utility: {
      margin: '0 auto'
    },
    utilityTitle: {
      width: '100%',
      height: '106px',
      // background: 'url(/images/home-utility-title.png) center no-repeat',
      // backgroundSize: '554px 106px'
      color: '#18181B',
      textAlign: 'center',
      fontFamily: 'Lexend',
      fontSize: '64px',
      fontWeight: '900',
      lineHeight: '78px',
      letterSpacing: '-1px',
      marginTop: '-20px',

      '& em': {
        display: 'inline-block',
        width: '100px',
        height: '100px',
        background: 'url(images/title-icon6.svg) left no-repeat',
        backgroundSize: '100px 100px',
        marginTop: '-60px',
        marginLeft: '-20px'
      }
    },
    utilityTitleMd: {
      width: '100%',
      // height: '48px',
      color: '#18181B',
      textAlign: 'center',
      fontFamily: 'Lexend',
      fontSize: '40px',
      fontWeight: '900',
      lineHeight: '48px',
      letterSpacing: '-1px',
      marginTop: '-20px',

      '& em': {
        display: 'inline-block',
        width: '50px',
        height: '50px',
        background: 'url(images/title-icon6.svg) left no-repeat',
        backgroundSize: '50px 50px',
        marginTop: '-30px',
        marginLeft: '-10px'
      }
    },
    titleText: {
      fontStyle: 'normal !important',
      fontWeight: '700 !important',
      fontSize: (props: any) => (props.mdDown ? '32px !important' : '48px !important'),
      lineHeight: (props: any) => (props.mdDown ? '40px !important' : '56px !important'),
      display: 'inline'
    },
    subText: {
      fontStyle: 'normal !important',
      fontWeight: '300 !important',
      // fontSize: (props: any) => (props.mdDown ? '16px !important' : '18px !important'),
      lineHeight: '24px !important'
    },
    imageViewer: {
      background: 'white',
      borderRadius: '8px'
    }
  })
);

export default observer(Utility);
